import { useStore } from "effector-react";
import { $clientId, $userRoles } from "./model";
import { useQuery } from "react-query";
import { getViewer } from "frontend/src/api/auth/get-viewer";
export var useViewerClientId = function () { return useStore($clientId); };
export var useViewer = function () {
    var _a = useQuery("user", function () { return getViewer(); }), data = _a.data, isLoading = _a.isLoading;
    return { user: data, isLoading: isLoading };
};
export var useViewerRoles = function () { return useStore($userRoles); };
